import React, { useState } from "react";
import "../../css/terms.scss";
import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

const Privacy = () => {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const [tocOpen, setTocOpen] = useState(false);
  const linkListRef = React.useRef(null);
  const containerRef = React.useRef(null);

  React.useEffect(() => {
    const linkList = linkListRef.current;
    const container = containerRef.current;
    if (!linkList || !container) return;

    const topOffset = 12; // matches CSS top for fixed state

    let initialTop = linkList.getBoundingClientRect().top + window.scrollY;

    function recalc() {
      initialTop = linkList.getBoundingClientRect().top + window.scrollY;
      onScroll();
    }

    function onScroll() {
      if (window.innerWidth > 768) {
        linkList.classList.remove("fixed");
        linkList.style.left = "";
        linkList.style.width = "";
        return;
      }
      const scrollY = window.scrollY || window.pageYOffset;
      if (scrollY + topOffset > initialTop) {
        if (!linkList.classList.contains("fixed")) {
          linkList.classList.add("fixed");
          // align fixed link-list to container
          const rect = container.getBoundingClientRect();
          linkList.style.left = `${rect.left}px`;
          linkList.style.width = `${rect.width}px`;
        }
      } else {
        if (linkList.classList.contains("fixed")) {
          linkList.classList.remove("fixed");
          linkList.style.left = "";
          linkList.style.width = "";
        }
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", recalc);
    // 鼠标悬停在 TOC 上时，可滚动 TOC 而不滚动页面（当目录展开时优先）
    function onWheel(e) {
      if (!linkList) return;
      // only act when TOC is open (expanded)
      if (!linkList.classList.contains("open")) return;
      const scrollEl =
        linkList.querySelector(".toc-list") || linkList.querySelector("ul");
      if (!scrollEl) return;
      const canScroll = scrollEl.scrollHeight > scrollEl.clientHeight;
      if (!canScroll) return;
      const delta = e.deltaY;
      const atTop = scrollEl.scrollTop === 0;
      const atBottom =
        Math.abs(
          scrollEl.scrollTop + scrollEl.clientHeight - scrollEl.scrollHeight
        ) < 1;
      if ((delta < 0 && atTop) || (delta > 0 && atBottom)) {
        return;
      }
      e.preventDefault();
      scrollEl.scrollTop += delta;
    }
    const scrollEl =
      linkList.querySelector(".toc-list") || linkList.querySelector("ul");
    if (scrollEl) {
      scrollEl.setAttribute("tabindex", "0");
      scrollEl.addEventListener("wheel", onWheel, { passive: false });
    } else {
      linkList.addEventListener("wheel", onWheel, { passive: false });
    }
    // initial
    recalc();
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", recalc);
      const scrollElCleanup =
        linkList.querySelector(".toc-list") || linkList.querySelector("ul");
      if (scrollElCleanup) {
        scrollElCleanup.removeEventListener("wheel", onWheel, {
          passive: false,
        });
      } else {
        linkList.removeEventListener("wheel", onWheel, { passive: false });
      }
      if (linkList) {
        linkList.classList.remove("fixed");
        linkList.style.left = "";
        linkList.style.width = "";
      }
    };
  }, []);
  return (
    <div>
      <Header />
      <main className="terms_main">
        <section
          id="hero"
          className="large-and-concise block_36269acd4b041706b522d09580a42a49 hero"
        >
          <div className="hrt-global-wrapper">
            <div className="hero-inner content-width-xlg">
              <div className="title-wrapper">
                <h1 className="title">Privacy Notice</h1>
              </div>
            </div>
          </div>
        </section>

        <section
          className="block block-long-form-content-with-sidebar block_a3fa11208e55c411e7228edd5d0d849f"
          id="section-1"
        >
          <div className="container-outer" ref={containerRef}>
            <div className="content-wrapper">
              <div className="main-content">
                <h2 id="h2-number-1">Our Privacy Notice</h2>
                <p>
                  <strong>Last Updated: May 26, 2026</strong>
                </p>
                <p>
                  GoFundMe Inc. together with its affiliates and subsidiaries,
                  including GoFundMe Ireland, Limited and GoFundMe International
                  Services UK Ltd (collectively, “GoFundMe” “we,” “our,” and
                  “us”), provide this Privacy Notice (“Notice”) to explain how
                  we collect, use, and disclose information about you when you
                  interact with us offline and on any products or services on
                  which we make this Notice available. The “Services” refers to
                  all the products and services that we offer, including for
                  example, when you use our mobile applications; raise funds or
                  otherwise use any services on GoFundMe or GoFundMePro; or
                  donate to one of our non-profit customers through our suite of
                  online fundraising tools, services, and technology solutions
                  provided by GoFundMe to nonprofits (“GoFundMe Pro Software”).
                </p>
                <p>
                  Depending on the context, “you” might be a User or a GoFundMe
                  Pro Client:
                </p>
                <ul>
                  <li>
                    <strong>Users</strong>. Our users on GoFundMe.com who
                    donate, start fundraisers, are beneficiaries or otherwise
                    interact with the Services or our users who donate or
                    fundraise through the GoFundMe Pro Software used on our
                    customer’s websites with whom we have a direct relationship
                    when we collect their information under this Notice.
                  </li>
                  <li>
                    <strong>GoFundMe Pro Clients</strong>. Our customers that
                    are non-profit organizations (“NPOs”) and that use our
                    GoFundMe Pro Software, and their employees, contractors, and
                    other authorized representatives.
                  </li>
                </ul>
                <p>
                  Before you access, use, or submit any information through or
                  in connection with the Services, please carefully review this
                  Notice. By using any part of the Services, you acknowledge
                  that you have read and understood that we may collect, use,
                  and disclose information about you as outlined in this Notice.
                  To the extent allowed by law, the English version of this
                  Notice is binding, and its translations in other languages are
                  for convenience only; in case of discrepancies between the
                  English version of this Notice and its translations, the
                  English version shall prevail.
                </p>
                <p>
                  This Notice does not cover the privacy practices of (i)
                  organizers of GoFundMe fundraisers (collectively,
                  “Organizers”), (ii) beneficiaries of fundraisers
                  (collectively, “Beneficiaries”), or (iii) GoFundMe Pro
                  Clients. We are not responsible for the privacy practices of
                  Organizers, Beneficiaries, or GoFundMe Pro Clients, and their
                  handling of your information may be subject to their own
                  privacy statements.
                </p>
                <p>
                  This Notice also does not apply when we act as a “processor”
                  or “service provider” on behalf of GoFundMe Pro Clients, nor
                  does it apply when we receive donor information from a
                  GoFundMe Pro Client to provide the Services, without having a
                  direct relationship with the donors themselves. In those
                  circumstances, we process information about these donors on
                  behalf of the GoFundMe Pro Client, and these Users should
                  consult the privacy statement of the respective GoFundMe Pro
                  Client they donated to for information on their privacy
                  practices.
                </p>
                <p>
                  If you are a resident of California, the California Consumer
                  Privacy Act of 2018 provides you with additional rights.
                  Please view our “
                  <Link onClick={toTop} to="/privacy">
                    California Consumer Privacy Act Notice
                  </Link>
                  ” to learn more. For any other specific US state privacy
                  law-related matters, please refer to the sections below titled
                  “<a href="#h2-number-16">Regional Privacy Disclosures</a>” and
                  “<a href="#h2-number-15">Your Privacy Rights</a>
                  ”.
                </p>
                <h2 id="h2-number-2">GOFUNDME IS A PUBLIC PLATFORM</h2>
                <p>
                  Some parts of GoFundMe are public and can be viewed by anyone,
                  even if they don’t have an account. When you submit
                  information or content such as photos and videos to GoFundMe
                  to be posted on a public part of the Services, like fundraiser
                  pages, forums or comment sections, that information and
                  content may be visible to anyone, including public visitors
                  and Users of our Services. The content and information may
                  also be available in search results through search engines
                  like Google. Please note that information you choose to share
                  publicly is not subject to the same legal protections that
                  apply to non-public personal data under certain data
                  protection laws. We encourage you to consider what personal
                  details you include in publicly available content. By using
                  the Services, and posting to public-facing portions of the
                  Services, you are directing us to share certain information
                  publicly and freely.
                </p>
                <p>
                  Your GoFundMe account may include a profile page. You can
                  choose to make your profile public or keep it private by
                  editing your settings.{" "}
                  <Link onClick={toTop} to="/">
                    Learn more
                  </Link>
                  .
                </p>
                <h2 id="h2-number-3">INFORMATION WE COLLECT</h2>
                <p>
                  As further described below, we collect information in multiple
                  ways, including when you provide information directly to us,
                  when we collect information about you from other parties, and
                  when we automatically collect information from your browser or
                  device (e.g., by logging how you interact with our Services).
                </p>
                <h3 style={{ paddingLeft: 40 }}>
                  A. Information That You Provide Directly to Us or Our Vendors:
                </h3>
                <h4 style={{ paddingLeft: 40 }}>
                  I. Information Directly Collected
                </h4>
                <p style={{ paddingLeft: 40 }}>
                  We and our vendors may collect information from you directly
                  in various ways, such as when you:
                </p>
                <ul>
                  <li style={{ listStyleType: "none" }}>
                    <ul>
                      <li style={{ listStyleType: "none" }}>
                        <ul>
                          <li>
                            Open an account or otherwise access, use, interact,
                            or register for the Services;
                          </li>
                          <li>
                            Create a profile, fundraiser, peer-to-peer,
                            crowdfunding, or team page on the Services or are a
                            beneficiary for any such fundraiser;
                          </li>
                          <li>
                            Share a fundraiser or information about an
                            individual or an NPO;
                          </li>
                          <li>
                            Link your individual contacts or address book to
                            your GoFundMe account and share information about
                            your contacts on your phone, email, or social media
                            accounts with GoFundMe;
                          </li>
                          <li>
                            Create, register for, or purchase tickets to events,
                            and/or other activities, and purchase merchandise;
                          </li>
                          <li>
                            Set up withdrawals, transfers, or authorize payment
                            transactions, including automated clearing house
                            (“ACH”) transactions;
                          </li>
                          <li>
                            Donate to a fundraiser, organization, or cause,
                            whether online, at events or through the phone;
                          </li>
                          <li>
                            Post comments, leave feedback, send thank-you notes,
                            message or otherwise communicate with other Users
                            through our Services;
                          </li>
                          <li>
                            Fill out a survey or questionnaire or provide us
                            with feedback regarding the Services;
                          </li>
                          <li>
                            Request certain features (e.g., newsletters,
                            updates, and other products);
                          </li>
                          <li>
                            Sign up for contests, awards and events hosted by
                            us;&nbsp; or
                          </li>
                          <li>
                            Play or share published videos, podcasts or other
                            media content.
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
                <p style={{ paddingLeft: 40 }}>
                  The information you provide directly to us or our vendors may
                  relate to you or others and may include, without limitation:
                </p>
                <p style={{ paddingLeft: 40 }}>
                  <em>Account Registration Information</em>: such as your name,
                  email address, login details, zip code, country, phone number,
                  occupation, and any additional information, such as your
                  profile picture or your date of birth. If you use the Services
                  as an organization (e.g., by claiming your NPO page on
                  gofundme.com or as a GoFundMe Pro Client or any other
                  registered non-profit), you may also provide us with your
                  organization’s name, your role/title within the organization,
                  tax identification number, 501(c)3 or tax-exempt status, and
                  other information about your organization such as its logo and
                  mission statement.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  <em>Contact Information</em>: If you choose to import your
                  personal contacts on to your GoFundMe account, GoFundMe will
                  collect information in your contacts, which may include
                  information such as the names, email addresses, zip codes,
                  locales, and phone numbers of people saved on your mobile
                  device or your connections when you connect any of your social
                  media accounts to GoFundMe. Learn more about how we collect
                  and use Contact Information, and the controls available to you{" "}
                  <Link onClick={toTop} to="/">
                    here
                  </Link>
                  .
                </p>
                <p style={{ paddingLeft: 40 }}>
                  <em>Fundraiser Information</em>: such as a fundraiser title,
                  location, fundraiser category, images, videos, description and
                  goal(s) for your fundraiser.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  <em>Financial Information</em>: such as payment account
                  details for withdrawals, billing information and other payment
                  information for donations, including any saved payment
                  methods.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  We use third-party payment processors to process financial
                  information. For example, we use Stripe, Adyen and PayPal for
                  payments, analytics, and other business services. These
                  payment processors may collect personal data, including
                  through cookies and similar technologies. The personal data
                  they collect includes transactional data, identifying
                  information about you, and information about the devices that
                  you use to access their services. They use this data to
                  operate and improve the services provided to us, including
                  fraud detection, loss prevention, authentication, and
                  performance analytics. They operate both as processors for us
                  and independent controllers for the information they collect
                  directly from you.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  To learn more about how these payment processors handle your
                  personal data, you can visit their privacy policies:
                </p>
                <ul>
                  <li style={{ listStyleType: "none" }}>
                    <ul>
                      <li style={{ listStyleType: "none" }}>
                        <ul>
                          <li>
                            Stripe:{" "}
                            <Link
                              onClick={toTop}
                              to="https://stripe.com/privacy"
                            >
                              https://stripe.com/privacy
                            </Link>
                            .
                          </li>
                          <li>
                            Adyen:{" "}
                            <Link
                              onClick={toTop}
                              to="https://www.adyen.com/policies-and-disclaimer/privacy-policy"
                            >
                              https://www.adyen.com/policies-and-disclaimer/privacy-policy
                            </Link>
                            .
                          </li>
                          <li>
                            PayPal:{" "}
                            <Link
                              onClick={toTop}
                              to="https://www.paypal.com/us/legalhub/paypal/privacy-full"
                            >
                              https://www.paypal.com/us/legalhub/paypal/privacy-full
                            </Link>
                            .
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
                <h4 style={{ paddingLeft: 40 }}>
                  II. Publicly Available and Non-Publicly Available
                  Communications and Content
                </h4>
                <p style={{ paddingLeft: 40 }}>
                  We may collect information that you share such as comments,
                  feedback, thank-you notes or other communications with other
                  Users through our Services. Any such content that you choose
                  to post on publicly available pages through our Services is
                  available to the public by default. Please remember that any
                  information that is disclosed becomes public information and
                  can be viewed, used, or shared by others, including us. Take
                  care not to disclose information about yourself unless you
                  intend for that data to become public. Please also be
                  considerate and respectful of others while using the community
                  to publish your opinions. We reserve the right, but do not
                  have the obligation, to review and monitor publicly-available
                  content, non-publicly available communications between Users,
                  and any other content made on or through our Services that may
                  be used for internal analytics, and to remove postings or
                  content that may be viewed as inappropriate or offensive.
                </p>
                <h4 style={{ paddingLeft: 40 }}>
                  III. Information about Yourself and Others, Including
                  Sensitive Information
                </h4>
                <p style={{ paddingLeft: 40 }}>
                  We may collect information about a fundraiser, including the
                  beneficiary of a fundraiser, fundraiser goals, and other
                  information you choose to provide, which may include
                  information about situations or other circumstances that
                  motivate a fundraising request. This information may include
                  personal or sensitive details, depending on the information
                  you choose to share, such as political opinions, race,
                  ethnicity, health information, or religious beliefs. If you
                  post this information in a fundraiser, you choose to provide
                  such information to be published publicly in relation to your
                  fundraiser, donation, or otherwise. Subject to applicable law,
                  GoFundMe may process or use any information that has
                  manifestly been made public, including information about you
                  or others that reveals sensitive information.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  If you provide us with information about others, like by
                  sharing your contacts list or address book with us, you
                  acknowledge and agree that you have the authority and consent
                  of the relevant other parties for us to access, disclose, and
                  use the relevant data, and that you have notified the other
                  parties and informed them of how their information is
                  collected and used by us to provide the Services. We reserve
                  the right to identify you as the person who has made the
                  referral in any messages that are sent to them.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  If you do not create a GoFundMe account or otherwise use our
                  Services, your information might still be collected through
                  features like when a User shares their contact list.
                </p>
                <h4 style={{ paddingLeft: 40 }}>
                  IV. Chats and Other Communications with Us
                </h4>
                <p style={{ paddingLeft: 40 }}>
                  We may collect information for troubleshooting or support
                  services when you call or chat with us. We may engage vendors
                  to provide certain features, such as chat features (including
                  AI chatbots) on our Services. Your use of these features is
                  voluntary, and we (and our vendors) may record your calls with
                  our support service and retain the transcripts or call
                  recordings including for training and quality assurance
                  purposes. For example, we may offer an interactive chat
                  feature on the Services for customer service purposes or as an
                  interactive “coach” to help you launch your fundraiser or
                  attract more donors. We would ask that you take care not to
                  send financial or health information, data about minors
                  without their parent or guardian’s consent, or other sensitive
                  personal data to us through our chat services or other means.
                  When you provide such information to us directly, we will only
                  process this information if we have a legal basis for doing
                  so. We collect the information listed in this section for the
                  purposes described below in the sections “
                  <a href="#h2-number-4">Our Use of Information Collected</a>”
                  and “
                  <a href="#h2-number-5">
                    Our Disclosure of Information Collected About You
                  </a>
                  .”
                </p>
                <h4 style={{ paddingLeft: 40 }}>V. Biometric Information</h4>
                <p style={{ paddingLeft: 40 }}>
                  We sometimes engage vendors to collect biometric information
                  for identity verification, regulatory compliance, and fraud
                  prevention purposes. We or the vendors we engage may collect a
                  copy of your government-issued ID (i.e., your driver’s
                  license, state ID card, or passport) and a scan of the picture
                  on your government-issued ID for identification purposes. Our
                  vendors may, with your consent, employ facial recognition
                  technology to verify your identity and share the results of
                  their analysis with us, if needed. GoFundMe does not have
                  access to or otherwise collect or maintain any biometric
                  information. Your biometric information will be retained by
                  our vendors in compliance with applicable laws, and subject to
                  their retention and privacy policies.
                </p>
                <h3 style={{ paddingLeft: 40 }}>
                  B. Information We Collect from Other Parties:
                </h3>
                <h4 style={{ paddingLeft: 40 }}>
                  I. Data Enhancement Information
                </h4>
                <p style={{ paddingLeft: 40 }}>
                  GoFundMe uses vendors to improve the quality of our User
                  platform so that we might improve or market our Services to
                  you, for verification, compliance and fraud prevention
                  purposes, and as otherwise described in this Notice. In
                  addition, GoFundMe obtains contact details and other personal
                  information regarding media contacts and influencers from
                  various groups such as Cision and Muck Rack. See the{" "}
                  <Link onClick={toTop} to="/privacy">
                    Cision privacy policy
                  </Link>{" "}
                  and the{" "}
                  <Link onClick={toTop} to="/privacy">
                    Muck Rack privacy policy
                  </Link>{" "}
                  for further information.
                </p>
                <h4 style={{ paddingLeft: 40 }}>
                  II. Payment Processing Information
                </h4>
                <p style={{ paddingLeft: 40 }}>
                  Our payment processors collect and provide certain information
                  about You to us in order for us and them to process any
                  payments you make on GoFundMe, or any money you may be
                  eligible to withdraw. For example, when you donate to a
                  fundraiser or NPO on GoFundMe via ACH using Plaid
                  Technologies, Inc. (“Plaid”), we may use Plaid to gather
                  certain data from financial institutions, like your name,
                  email, bank information, zip code, and country. By electing to
                  link to Plaid, you (i) grant us and Plaid the right, power,
                  and authority to act on your behalf to access and transmit
                  your personal and financial information from the relevant
                  financial institution and (ii) you agree to your personal and
                  financial information being transferred, stored, and processed
                  by us and Plaid in accordance with this Notice and the{" "}
                  <Link onClick={toTop} to="/">
                    Plaid Privacy Policy
                  </Link>
                  .
                </p>
                <h4 style={{ paddingLeft: 40 }}>
                  III. Account and Profile Information from Third-Party Services
                </h4>
                <p style={{ paddingLeft: 40 }}>
                  One of the special features of some of the Services is that
                  they allow you to enable or log into the Services via various
                  applications/services, including social media
                  applications/services, like Facebook, X, LinkedIn, Google or
                  Apple, or to upload videos using YouTube APIs (each and
                  collectively, the “Third-Party Service(s)”).
                </p>
                <p style={{ paddingLeft: 40 }}>
                  By directly integrating these Third-Party Services, we aim to
                  make your online experiences richer and more personalized.
                  Some features may also allow you to schedule posts on
                  Third-Party Services through our platform. If you choose to
                  use this scheduling tool, you will have control over when,
                  where, and how posts are published. While we enable you to
                  provide the content for these posts, you can decide whether to
                  use this feature. We will never post on your behalf without
                  you actively setting up and authorizing the post schedule.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  To take advantage of these features, we will ask you to
                  provide your credentials for the applicable Third-Party
                  Services in order to log in to our Services. When you add a
                  Third-Party Services account to the Services or log into the
                  Services using your Third-Party Services account, we will
                  collect the relevant information necessary to enable the
                  Services to access that Third-Party Service. As part of such
                  integration, the Third-Party Service will provide us with
                  access to certain information that you have provided to the
                  Third-Party Service and made available to us based on your
                  privacy settings with the Third-Party Service (for example,
                  your name and photograph, as well as other information that
                  you permit the Third-Party Service to share with us). We will
                  use, store, and disclose such information in accordance with
                  this Notice. However, please remember that the manner in which
                  Third-Party Services use, store, and disclose your information
                  is governed by the policies of such third parties, and
                  GoFundMe shall have no liability or responsibility for the
                  privacy practices or other actions of any Third-Party Services
                  that may be enabled within the Services. For example, if you
                  upload a video onto your fundraiser using the mobile
                  application for the Services, your video will be uploaded
                  using YouTube and subject to Google’s{" "}
                  <Link
                    onClick={toTop}
                    to="https://policies.google.com/privacy?hl=en-US"
                  >
                    Privacy Policy
                  </Link>{" "}
                  and{" "}
                  <Link
                    onClick={toTop}
                    to="https://policies.google.com/terms?hl=en-US"
                  >
                    Terms of Service
                  </Link>
                  .
                </p>
                <p style={{ paddingLeft: 40 }}>
                  You further acknowledge that if you choose to use this
                  feature, your friends, followers, and subscribers on any
                  Third-Party Services you have enabled may be able to view such
                  activity. For example, if you sign on using Meta, Meta’s{" "}
                  <Link
                    onClick={toTop}
                    to="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0"
                  >
                    Privacy Policy
                  </Link>{" "}
                  and{" "}
                  <Link onClick={toTop} to="https://www.facebook.com/terms/">
                    Terms of Service
                  </Link>{" "}
                  would apply to the data Meta might obtain from your activities
                  on GoFundMe. Similarly, if you sign on using Google, Google’s
                  Privacy Policy and Terms of Service would apply to the data
                  Google might obtain from your activities on GoFundMe. Please
                  visit the terms of use and privacy policy of the relevant
                  Third Party Service to learn more about your rights and
                  choices, and to exercise your choices about those
                  technologies.
                </p>
                <h3 id="info" style={{ paddingLeft: 40 }}>
                  C. Information That is Passively or Automatically Collected:
                </h3>
                <h4 style={{ paddingLeft: 40 }}>
                  I. Device &amp; Browser Information:
                </h4>
                <p style={{ paddingLeft: 40 }}>
                  When you interact with GoFundMe through the Services, we
                  automatically receive and store certain information from
                  devices and browsers that you use to access or view the
                  Services. This information is collected passively and includes
                  your cookie IDs, social network ID, mobile device ID, mobile
                  advertising IDs, the website from which you have come to the
                  Services, and your IP address to estimate your general
                  location (as described further below under “
                  <a href="#location-information">Location Information</a>
                  ”).
                </p>
                <p style={{ paddingLeft: 40 }}>
                  We will also receive information about your browser or device
                  type, operating system, network information, our mobile
                  application’s configurations, and other such technical
                  metadata. This information may be used by us and/or our
                  vendors, together with the other information we receive as
                  provided in this Notice, including to recognize your device or
                  browser, to identify you or for fraud detection, fraud
                  prevention or security purposes.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  We may also collect information about the photos or videos you
                  upload to our Services. For example, if you upload a photo to
                  the Services, depending on your device settings we may receive
                  the date, time, and location it was taken. We may use this
                  metadata to make inferences about your general location for
                  the purposes described below, as explained in “
                  <a href="#h2-number-4">Our Use of Information Collected</a>”
                  section of this Notice.
                </p>
                <h4 id="location-information" style={{ paddingLeft: 40 }}>
                  <strong>II. Location Information:</strong>
                </h4>
                <p style={{ paddingLeft: 40 }}>
                  We may use your IP address to infer the postcode/zip code,
                  city or town, state or province and country of residence. This
                  imprecise location information is used to provide you with an
                  optimized browsing experience, suggest donations or tips to
                  you, to recommend fundraisers or community activities within
                  your general area, and as otherwise set forth in this Notice.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  When you use the Services to organize a fundraiser, the
                  Services may require that you provide your postcode/zip code,
                  city or town, and state or province of residence. Please keep
                  in mind that other users of the Services can view your
                  postcode/zip code, city or town, and state or province of
                  residence in connection with the fundraiser.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  If you install our mobile application, we may ask you to grant
                  us access to your mobile device’s precise geolocation data. If
                  you grant such permission, we may collect information about
                  your precise geolocation, and we may use that information to
                  improve the Services we provide to you, such as providing you
                  with location-based features (e.g., to prepopulate your post
                  code/zip code or to identify fundraisers near you). You may
                  also give us access to your location using the setting
                  configurations on your web browser. Certain devices or
                  operating systems may permit you to opt out of providing your
                  precise geolocation information. Please check your settings if
                  you want to limit such tracking. If you have any questions
                  about the privacy settings of your device or operating system,
                  we suggest you contact the manufacturer of your device or
                  operating system for help.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  We may also use your imprecise or precise location information
                  in an aggregate way as described below in the “
                  <a href="#aggregateddata">Aggregated Data</a>” section.
                </p>
                <h4 style={{ paddingLeft: 40 }}>
                  III. Site Usage &amp; Session Information:
                </h4>
                <p style={{ paddingLeft: 40 }}>
                  We collect information about your interaction with our
                  Services, including the resources that you access, pages
                  viewed, how much time you spent on a page, and how you reached
                  our website. We may also use session replay technology to
                  collect information on a real-time basis and log the details
                  of your visits to our website and information generated in the
                  course of using our website, such as mouse movements, clicks,
                  taps, swipes, page visits, how long you spent on a page, and
                  other details of your actions on our website, including
                  information you view. We may share this information with our
                  agents/vendors to analyze and organize any collected data on
                  our behalf and at our express direction.
                </p>
                <h3 style={{ paddingLeft: 40 }}>
                  IV. Cookies &amp; Other Electronic Technologies:
                </h3>
                <p style={{ paddingLeft: 40 }}>
                  Please review the “
                  <a href="#h2-number-7">
                    Online Analytics and Targeted Advertising
                  </a>
                  ” section below as well as our{" "}
                  <Link onClick={toTop} to="/privacy">
                    Cookie Policy
                  </Link>{" "}
                  for information on the types of cookies and similar
                  technologies that we or our vendors use on the Services, like
                  on our websites and mobile apps, how we use these
                  technologies, and how you can manage your Cookie and mobile
                  privacy preferences.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  Some web and mobile device browsers may accept cookies by
                  default. If you prefer, you can usually change your browser to
                  prevent that or to notify you each time a new cookie is set.
                  You can turn off non-essential cookies, but some or all of our
                  Services may not work as intended. Essential cookies cannot be
                  turned off because they ensure the site works as it should.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  As to the information in this “Information That is Passively
                  or Automatically Collected” Section, GoFundMe either stores
                  such information itself or such information is included in
                  databases owned and maintained by GoFundMe, and/or its agents
                  or vendors.
                </p>
                <h2 style={{ textAlign: "left" }} id="h2-number-4">
                  OUR USE OF INFORMATION COLLECTED
                </h2>
                <p>
                  GoFundMe uses the information collected from the Services in a
                  manner that is consistent with this Notice. We may use the
                  information that you provide (or otherwise permit the Services
                  to access) for the following purposes:
                </p>
                <h3 style={{ paddingLeft: 40 }}>A. Provision of Services</h3>
                <p style={{ paddingLeft: 40 }}>
                  To provide, operate, and maintain the Services, including to
                  register and maintain your account, add information to your
                  Profile and to facilitate financial transactions. In order to
                  provide certain Services, we would verify your identity,
                  facilitate the Know Your Customer (“KYC”) verification
                  process, and use your information to detect and prevent fraud
                  or other misuses of the Services. We will also use your data
                  to communicate with you for various purposes, including to
                  help you fundraise or donate to a cause, share updates with
                  you, request your feedback or for administrative purposes
                  (e.g., to provide services and information that you request or
                  to respond to comments and questions) regarding the Services.
                  If you import your personal contacts to your GoFundMe account,
                  we will use that information as needed to help you raise more
                  funds for your fundraiser on GoFundMe.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  We may also communicate with you regarding your GoFundMe
                  account by SMS, MMS, or text message. For example, when
                  setting up your GoFundMe account, if you click “Send code”,
                  you agree to receive automated and nonautomated text messages
                  related to your account from or on behalf of GoFundMe at the
                  phone number provided. You can reply STOP to such text
                  messages to cancel, except for automated text messages related
                  to the security of your account. Message frequency will vary.
                  Except when we collect mobile numbers on behalf of GoFundMe
                  Pro Clients on their websites, we do not share mobile phone
                  numbers with any third parties for them to use for their own
                  marketing/promotional purposes. If we intend to share a mobile
                  number in other instances, we will first check with you for
                  any objections before proceeding. We will not use text
                  messaging originator opt-in data or consent for other types of
                  communication (such as email), nor will we share this
                  information with third parties, except as outlined in this
                  Notice. In the event you change or deactivate your mobile
                  telephone number, you agree to promptly update your GoFundMe
                  account information to ensure that your messages are not
                  misdirected. Please note that your wireless service carrier’s
                  standard charges, message and data rates, and other fees may
                  apply where you access the Services through a mobile device.
                  In addition, downloading, installing, or using certain
                  Services on a mobile device may be prohibited or restricted by
                  your carrier, and not all Services may work with all carriers
                  or devices. For more information, please refer to the SMS
                  Terms of Service{" "}
                  <Link onClick={toTop} to="/terms">
                    here
                  </Link>
                  .
                </p>
                <h3 style={{ paddingLeft: 40 }}>
                  B. Personalization of our Services
                </h3>
                <p style={{ paddingLeft: 40 }}>
                  We may use information to analyze, improve, modify,
                  personalize, and measure the Services, including to optimize
                  our websites, and develop and train our artificial
                  intelligence (“AI”) or machine learning (“ML”) models. We do
                  not use your data to train AI models for the development of
                  general-purpose commercial AI products that are unrelated to
                  the Services.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  We may use AI, ML, and other analytics tools to further
                  enhance your experience on our platform and to develop the
                  Services. These tools are offered to help Users create, draft
                  and promote fundraisers; create and share posts, photos or
                  videos to share their fundraisers; as a conversational chatbot
                  to assist during the fundraiser creation and management
                  process; or to otherwise optimize the use of our Services. We
                  also may use tools to tailor emails to you, make
                  recommendations, highlight causes, fundraisers, and pages
                  likely to interest you, to protect you and your account from
                  misuse, and to make suggestions about prospective donors and
                  fundraising goals or donation amounts. Also, we may suggest
                  you start a fundraiser for your birthday if you have provided
                  your date of birth to us.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  For our GoFundMe Pro Clients, we offer an Intelligent Ask
                  Amounts (IAA) feature that suggests a personalized donation
                  amount to donors. If you prefer we not use your data for IAA,
                  submit an opt-out request{" "}
                  <Link onClick={toTop} to="/">
                    here
                  </Link>
                  .
                </p>
                <p style={{ paddingLeft: 40 }}>
                  We and our AI vendors may collect and retain transcripts or
                  other data from your interactions with us for training,
                  content moderation, and quality assurance purposes. When you
                  provide such information to us directly, you consent to the
                  processing of this data by GoFundMe and/or our AI vendors.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  We may use the information we collect from you, such as the
                  NPOs or fundraisers you donated to, the NPOs or fundraisers
                  you pinned or added to your lists of fundraisers and NPOs you
                  care about, the causes you selected to support or share, and
                  the people you follow or message, to draw inferences based on
                  your profile and interactions with our Services. These
                  inferences help us personalize your experience. For example,
                  we may infer what you are interested in or suggest public
                  profiles for you to follow based on the causes you have
                  donated to and will provide recommendations to you based on
                  these inferences, or we may infer information from the contact
                  list you’ve shared to suggest more targeted sharing of your
                  fundraiser. In some instances, we may rank content more highly
                  in your feed if it relates to a cause that we infer interests
                  you or based on the users you interact with on our Services.
                </p>
                <h3 style={{ paddingLeft: 40 }}>
                  C. Improve our Services for You
                </h3>
                <p style={{ paddingLeft: 40 }}>
                  We may use information to develop new products and services
                  and for other research and development;
                </p>
                <h3 style={{ paddingLeft: 40 }}>
                  D. Fraud Detection and Security
                </h3>
                <p style={{ paddingLeft: 40 }}>
                  We may use information to maintain the security of your
                  account and any associated fundraisers;
                </p>
                <h3 style={{ paddingLeft: 40 }}>
                  E. Compliance with Legal Obligations
                </h3>
                <p style={{ paddingLeft: 40 }}>
                  We may use information to comply with legal obligations, law
                  enforcement requests and legal processes, and to protect our
                  rights, privacy, safety, or property, and/or that of our
                  affiliates, you, or other parties, including to enforce our
                  Terms of Service and any other agreements; and
                </p>
                <h3 style={{ paddingLeft: 40 }}>F. Other Purposes</h3>
                <p style={{ paddingLeft: 40 }}>
                  We may also aggregate, hash and/or de-identify information
                  collected through the Services. We may use and disclose
                  aggregated, hashed and/or de-identified information for any
                  purpose, including, without limitation, research, marketing
                  purposes and as described in the “
                  <a href="/privacy#h2-number-7">
                    Online Analytics and Targeted Advertising
                  </a>
                  ” section below.
                </p>
                <h2 id="h2-number-5">
                  OUR DISCLOSURE OF INFORMATION COLLECTED ABOUT YOU
                </h2>
                <p>
                  There are certain circumstances in which we disclose
                  information collected about you with certain other parties
                  without further notice to you, as set forth below.
                </p>
                <h3 style={{ paddingLeft: 40 }}>
                  <strong>A. Business Transfers:</strong>
                </h3>
                <p style={{ paddingLeft: 40 }}>
                  As we develop our business, we might sell or buy businesses or
                  assets. In the event of a corporate sale, merger,
                  reorganization, dissolution, similar event, or steps taken in
                  anticipation of such events (e.g., due diligence in a
                  transaction), user information may be part of the reviewed and
                  transferred assets.
                </p>
                <h3 style={{ paddingLeft: 40 }}>
                  <strong>B. Affiliates and Subsidiaries:</strong>
                </h3>
                <p style={{ paddingLeft: 40 }}>
                  We disclose your personal information among the GoFundMe
                  entities, including our affiliates and subsidiaries, for
                  purposes consistent with this Notice, such as to provide our
                  Services, including hosting, marketing, and publicizing
                  fundraisers; providing you with customer support;
                  administering funds in connection with fundraisers; preventing
                  fraud and misuse; authenticating donors; sending you
                  communications; improving Services offered by the various
                  GoFundMe entities and conducting the other activities
                  described in this Notice.
                </p>
                <h3 style={{ paddingLeft: 40 }}>
                  <strong>C. Agents, Consultants, and Vendors:</strong>
                </h3>
                <p style={{ paddingLeft: 40 }}>
                  GoFundMe contracts with other companies to help us perform
                  certain business-related functions, and we provide access to
                  or disclose your information with these companies so they can
                  perform services for us. Examples of such functions include
                  marketing, mailing information, data storage, security,
                  identity verification, fraud prevention, payment processing,
                  preventing fraud and misuse, legal services, and database
                  maintenance.{" "}
                  <span style={{ fontWeight: 400 }}>
                    If you are based in Canada, you understand that GoFundMe
                    will use third party service providers to check your
                    personal information you provide GoFundMe against various
                    databases including credit reporting agencies and
                    telecommunications providers for the purpose of identity
                    verification.{" "}
                  </span>
                  Our websites and checkout experiences for our GoFundMe Pro
                  Clients are protected by reCAPTCHA and the Google{" "}
                  <Link
                    onClick={toTop}
                    to="https://policies.google.com/privacy"
                  >
                    Privacy Policy
                  </Link>{" "}
                  and{" "}
                  <Link onClick={toTop} to="https://policies.google.com/terms">
                    Terms of Service
                  </Link>{" "}
                  apply.
                </p>
                <h3 style={{ paddingLeft: 40 }}>
                  <strong>D. Legal Requirements:</strong>
                </h3>
                <p style={{ paddingLeft: 40 }}>
                  We may transfer, disclose to, and preserve your information
                  for courts, law enforcement, governmental or public
                  authorities, tax authorities, or authorized third parties, if
                  and to the extent we are required or permitted to do so by law
                  or where disclosure is reasonably necessary to: (i) comply
                  with our legal obligations, (ii) comply with a valid legal
                  request (such as a subpoena or court order), (iii) respond to
                  claims asserted against us, (iv) respond to a valid legal
                  request relating to a criminal investigation to address
                  alleged or suspected illegal activity or to respond to or
                  address any other activity that may expose us, you or any
                  other of our users or members of the public to imminent harm,
                  legal or regulatory liability, (v) enforce and administer our
                  Terms of Service or other policies, or (vi) protect the
                  rights, property or personal safety of GoFundMe, its
                  affiliates, its employees, its Users, or members of the
                  public.
                </p>
                <h3 style={{ paddingLeft: 40 }}>
                  E. Organizers, NPO Beneficiaries, and GoFundMe Pro Clients:
                </h3>
                <h4 style={{ paddingLeft: 40 }}>I. Organizers.</h4>
                <p style={{ paddingLeft: 40 }}>
                  We disclose information about donors to Organizers, which can
                  be either an individual or an NPO. In some cases, the
                  Organizer of a fundraiser is also the Beneficiary, meaning
                  they are raising funds for themselves, while in others they
                  are different parties. For example, your contact information
                  may be shared with the Organizer or the Beneficiary so that
                  they can send you a thank you message, provide you a receipt,
                  or contact you about the fundraiser.
                </p>
                <h4 style={{ paddingLeft: 40 }}>II. NPO Beneficiaries.</h4>
                <p style={{ paddingLeft: 40 }}>
                  Organizers may create fundraisers designating an NPO as a
                  beneficiary.&nbsp; Where an NPO is designated as the
                  Beneficiary, that NPO may access certain information about the
                  Organizer and donors, including the Organizer’s or donor’s
                  name, email address, donation amount, date of transaction,
                  transaction identification number, and name of the campaign,
                  where applicable. If you start a fundraiser for an NPO, you
                  authorize us to disclose your information, such as your name
                  and email, to the NPO for whom you are fundraising. Likewise,
                  if you donate to an NPO or one of our GoFundMe Pro Clients
                  through the GoFundMe Software, you direct us to disclose your
                  donation, contact information and any other information you
                  provide to the applicable GoFundMe Pro Client. GoFundMe
                  contractually requires NPOs to use such information solely to
                  communicate with you about their legal compliance or
                  fundraising purposes.
                </p>
                <h4 style={{ paddingLeft: 40 }}>
                  III. GoFundMe Pro Clients and Their Vendors/Partners.
                </h4>
                <p style={{ paddingLeft: 40 }}>
                  If you donate to a GoFundMe Pro Client through our GoFundMe
                  Pro Software, which powers the donation page and other pages,
                  you direct us to disclose your donation and contact
                  information to the applicable GoFundMe Pro Client, and such
                  information shall also be subject to the privacy policies and
                  practices of that GoFundMe Pro Client. GoFundMe Pro Clients
                  may also direct us to further disclose your personal
                  information to other third parties such as the Client
                  Relationship Management (“CRM”) tools or other integration
                  partners used by the relevant GoFundMe Pro Client through APIs
                  or webhooks. We may also disclose certain information about
                  you, such as information about your interests and donation
                  preferences, to GoFundMe Pro Clients who may use such data for
                  their fundraising and marketing operations only to the extent
                  permitted by any stated consent preferences provided.
                </p>
                <h4 style={{ paddingLeft: 40 }}>
                  IV. “Anonymous” Donations Limited to Public Activity Feeds.
                </h4>
                <p style={{ paddingLeft: 40 }}>
                  If you selected not to be named publicly on the public
                  fundraiser pages on the Services, while your donation will be
                  designated as “anonymous” on the public activity feed, your
                  name and other information may still be visible to the
                  GoFundMe Pro Client, Organizer, any of their team members and
                  the Beneficiary, and will be otherwise processed in accordance
                  with this Notice.
                </p>
                <h3 style={{ paddingLeft: 40 }}>
                  <strong>F. Your Consent</strong>
                </h3>
                <p style={{ paddingLeft: 40 }}>
                  In certain situations, we may disclose your information when
                  you consented to the disclosure of your information. For
                  example, we may partner with third party organizations to
                  arrange for specific fundraisers. If you consent to our
                  providing your contact information to a specific partner, we
                  will disclose the following information with the partner
                  organization: your name, email address and other information
                  you have provided in connection with your donation to the
                  specific fundraiser. Additionally, with the applicable
                  Organizer’s or Beneficiary’s consent, we may provide their
                  personal information to journalists and media to help amplify
                  a campaign/fundraiser.
                </p>
                <h3 id="aggregateddata" style={{ paddingLeft: 40 }}>
                  <strong>G. Aggregated Data</strong>
                </h3>
                <p style={{ paddingLeft: 40 }}>
                  We aggregate, anonymize and/or de-identify information
                  collected actively or passively about you so that the
                  information no longer relates to you individually. We then use
                  that data for various legally permissible purposes, including
                  but not limited to our research on our customer demographics,
                  interests and behavior. We also disclose this information with
                  our affiliates, agents, business partners, research facilities
                  or other third parties.
                </p>
                <h3 style={{ paddingLeft: 40 }}>
                  <strong>H. Cookies and Other Electronic Technologies</strong>
                </h3>
                <p style={{ paddingLeft: 40 }}>
                  Information is disclosed as stated in the{" "}
                  <Link onClick={toTop} to="/">
                    Cookie Policy
                  </Link>
                  .
                </p>
                <h3 style={{ paddingLeft: 40 }}>
                  <strong>I. Other Users of Our Services</strong>
                </h3>
                <p style={{ paddingLeft: 40 }}>
                  We provide your information to other Users of our Services if
                  you choose to make your information publicly available in a
                  publicly accessible area of the Services, such as in your
                  fundraiser, through your donations, or in the comments.
                  Additionally, if you choose to make your personal profile
                  public, actions like when you donate to a fundraiser or start
                  one may appear in an activity feed to individuals who may
                  follow you.
                </p>
                <h2 id="h2-number-6">VOLUNTEERED INFORMATION</h2>
                <p>
                  We also collect information through forums and communities,
                  surveys and customer support communications, your
                  communication to us of ideas for new products or modifications
                  to existing products, feedback, and other solicited or
                  unsolicited submissions (collectively, with
                  publicly-accessible information, “Volunteered Information”).
                  Subject to applicable law, by sending us Volunteered
                  Information, you further agree that we are under no obligation
                  of confidentiality, express or implied, with respect to the
                  Volunteered Information. This Volunteered Information section
                  shall survive any termination of your account or the Services.
                </p>
                <h2 id="h2-number-7">
                  ONLINE ANALYTICS AND TARGETED ADVERTISING
                </h2>
                <h3 style={{ paddingLeft: 40 }}>A. Online Analytics.</h3>
                <p style={{ paddingLeft: 40 }}>
                  We may use third-party web and product analytics services on
                  the Services, such as Google Analytics. These vendors use the
                  sort of technology described in the “
                  <a href="#info">
                    Information That is Passively or Automatically Collected
                  </a>
                  ” section above to help us analyze how Users use the Services,
                  including by noting the third-party website from which you
                  arrive and in emails we send to you so we know whether you
                  open an email we sent to you or interact with its content. The
                  information collected by such technology will be disclosed to
                  or collected directly by these vendors, who use the
                  information to evaluate your use of the Services. We also may
                  use analytics services related to different kinds of
                  advertising, including targeted advertising as described in
                  the following section.
                </p>
                <h3 style={{ paddingLeft: 40 }}>B. Targeted Advertising.</h3>
                <p style={{ paddingLeft: 40 }}>
                  We may allow third-party advertising providers, such as
                  Google, TikTok, and Meta, to use cookies and similar tracking
                  technologies to collect information about your use of the
                  Services in order to (a) inform, optimize, and serve you
                  online ads based on your past visits to our website and other
                  online services and (b) measure, attribute and report on the
                  performance of our advertising efforts based on your
                  engagement with the ads. We may also provide third-party
                  advertising providers with data linked to or derived from data
                  you voluntarily have submitted to us (e.g., your email address
                  or phone number) in hashed, non-human-readable form. Cookies,
                  IP addresses, mobile device IDs and other such online
                  identifiers used for advertising may be associated with the
                  hashed IDs to enable the advertising services.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  You can learn more about the analytics and advertising
                  services we use by visiting our{" "}
                  <Link onClick={toTop} to="/">
                    Cookie Policy
                  </Link>
                  .
                </p>
                <h2 id="h2-number-8">CHILDREN</h2>
                <p>
                  Our Services are not designed for use by individuals under the
                  age of 18. If you are under the age of 18, please do not use
                  the Services and/or submit any information through the
                  Services. If you have reason to believe that a child under the
                  age of 18 has provided personal information to GoFundMe
                  through the Services, please contact us at{" "}
                  <Link onClick={toTop} to="mailto:legal@gofundme.com">
                    legal@gofundme.com
                  </Link>
                  , and we will delete that information from our databases to
                  the extent required by law.
                </p>
                <p>
                  Moreover, if you provide us with information about children
                  under the age of 18, you acknowledge and agree that either you
                  are the child’s parent/legal guardian or you have the
                  authority and consent of the child’s parent/legal guardian to
                  create a campaign/fundraiser and for us to access, disclose,
                  and use the relevant data.
                </p>
                <h2 id="h2-number-9">LINKS TO OTHER WEBSITES</h2>
                <p>
                  The Services can contain links to other websites not operated
                  or controlled by GoFundMe (the “Third-Party Sites”). The
                  policies and procedures we described here do not apply to the
                  Third-Party Sites. The links from the Services do not imply
                  that GoFundMe endorses or has reviewed the Third-Party Sites.
                  We suggest contacting those sites directly for information on
                  their respective privacy policies.
                </p>
                <h2 id="h2-number-10">CONTENT HOSTED ON OTHER WEBSITES</h2>
                <p>
                  The Services can contain videos, podcasts and other content
                  hosted on websites or platforms not operated or controlled by
                  GoFundMe, such as YouTube, Meta and TikTok. The policies and
                  procedures we described here only apply to the extent we
                  permit such content as part of our Services.
                </p>
                <h2 id="h2-number-11">SECURITY</h2>
                <p>
                  We may hold your information we have collected in paper and/or
                  electronic form. While no organization can guarantee perfect
                  security, GoFundMe has implemented and seeks to continuously
                  improve technical and organizational security measures to
                  protect the information provided via the Services from loss,
                  misuse, unauthorized access, disclosure, alteration, or
                  destruction. For details about our security practices, please
                  see{" "}
                  <Link onClick={toTop} to="/">
                    here
                  </Link>{" "}
                  for gofundme.com and{" "}
                  <Link onClick={toTop} to="/">
                    here
                  </Link>{" "}
                  for the GoFundMe Pro Software.
                </p>
                <h2 id="h2-number-12">RETENTION OF YOUR INFORMATION</h2>
                <p>
                  We retain your information for as long as we deem necessary
                  for the purpose for which that information was collected and
                  for our legitimate business operations; provided, however,
                  that your information is only retained to the extent permitted
                  or required by applicable laws. When determining the retention
                  period for your information, we take into account various
                  criteria, such as the type of products and services requested
                  by or provided to you, the nature and length of our
                  relationship with you, possible re-enrollment with our
                  products or services, the impact on the Services we provide to
                  you if we delete some information about you, mandatory
                  retention periods provided by law, and any applicable statute
                  of limitations.
                </p>
                <h2 id="h2-number-13">CROSS-BORDER DATA TRANSFERS</h2>
                <p>
                  GoFundMe is a global organization headquartered in the United
                  States, and we may process your information in various
                  countries, including the United States, India, Poland, and
                  Argentina. GoFundMe has implemented appropriate cross-border
                  transfer solutions, to provide adequate protection for
                  transfers of certain personal data to the United States, such
                  as execution of the Standard Contractual Clauses for transfers
                  of data from the European Economic Area, United Kingdom, and
                  Switzerland to the United States.
                </p>
                <h2 id="h2-number-14">USERS FROM OUTSIDE THE UNITED STATES</h2>
                <p>
                  The Services are hosted in the United States. If you are
                  visiting the Services from outside the United States, please
                  be aware that your information may be transferred to, stored,
                  and processed in the United States and other locations, such
                  as Argentina and India, where our servers and personnel are
                  located and our central database is operated. The data
                  protection and other laws of the United States and other
                  countries might not be as comprehensive as those in your
                  country, and data may be accessible to law enforcement and
                  national security authorities under certain circumstances.
                </p>
                <h2 id="h2-number-15">YOUR PRIVACY RIGHTS</h2>
                <p>
                  We offer you certain choices regarding the collection, use,
                  and disclosure of information about you.
                </p>
                <p>
                  <strong>Account Information</strong>. You may have the ability
                  to create an account in the Services. You may verify, correct,
                  update, or delete certain of your information through your
                  account profile page.
                </p>
                <p>
                  <strong>Direct Marketing Communications</strong>. Email and
                  text message marketing communications we send you will contain
                  instructions permitting you to “opt out” of receiving future
                  marketing communications. In addition, if at any time you wish
                  not to receive any future marketing communications or you wish
                  to have your name deleted from our mailing lists, please
                  contact us at the email address or mailing address set forth
                  under “<a href="#h2-number-17">Contacting GoFundMe</a>” and
                  provide us with details on your opt out request, including the
                  types of communications you seek to opt out of. If you opt out
                  of receiving marketing communications or other information we
                  think may interest you, we can still send you certain emails
                  about your account or any Services you have requested or
                  received from us.
                </p>
                <p>
                  <strong>Cookies and Similar Technologies</strong>. You can opt
                  out of certain analytics and targeted advertising related
                  processing by using the “Manage Cookie Preferences” link in
                  the footers of our Sites, or by following the additional
                  instructions provided in the Cookie Policy.
                </p>
                <p>
                  <strong>Rights to Information About You</strong>. Residents of
                  certain U.S. states including California, Colorado, Virginia,
                  Utah, Connecticut, Nevada, Oregon, Texas, Montana, Delaware,
                  Iowa, Nebraska, New Hampshire, New Jersey, Maryland,
                  Minnesota, Tennessee, Kentucky, Indiana, and Rhode Island,
                  have certain rights with respect to their information, but the
                  availability of these rights varies based on when the relevant
                  law takes effect in each state.
                </p>
                <p>Depending on your jurisdiction, you may:</p>
                <ul>
                  <li style={{ listStyleType: "none" }}>
                    <ul>
                      <li>
                        Request that we provide you with information about the
                        categories of personal information we collect or
                        disclose about you; the categories of sources of such
                        information; the business or commercial purpose for
                        collecting such information; and the categories of
                        unaffiliated parties to whom we disclose such personal
                        information. Such information is also set forth in this
                        Notice;
                      </li>
                      <li>
                        Request that we provide access to and/or a copy of
                        certain information we hold about you;
                      </li>
                      <li>
                        Request that we prevent the processing of your
                        information for direct marketing purposes (including any
                        direct marketing processing based on profiling);
                      </li>
                      <li>
                        Request that we update information which is out of date
                        or incorrect;
                      </li>
                      <li>
                        Request that we delete certain information that we are
                        holding about you;
                      </li>
                      <li>
                        Request that we restrict the way that we process and
                        disclose certain information about you;
                      </li>
                      <li>
                        Request that we transfer your information to a
                        third-party provider of services;
                      </li>
                      <li>
                        Opt out of the processing of your personal information
                        for purposes of automated decisionmaking/profiling in
                        furtherance of decisions that produce legal or similarly
                        significant effects, if applicable;
                      </li>
                      <li>
                        Revoke your consent for the processing of your
                        information provided that the withdrawal of consent
                        shall not affect the lawfulness of the processing based
                        on consent before its withdrawal; and
                      </li>
                      <li>
                        Exercise rights concerning sensitive information.
                        Depending on your jurisdiction, you may have the right
                        to opt out of or opt in to the processing of sensitive
                        information. Please note, generally, we only collect
                        sensitive information necessary to provide our Services
                        and we do not use or disclose sensitive information for
                        purposes to which the right to opt out or opt in applies
                        under privacy law. However, we may collect your precise
                        geolocation from your mobile device. You can opt out of
                        the processing of your precise geolocation in your phone
                        settings.
                      </li>
                    </ul>
                  </li>
                </ul>
                <p>
                  You may be able to designate an authorized agent to make
                  requests on your behalf. In order for an authorized agent to
                  be verified, you must provide the authorized agent with
                  signed, written permission to make such requests or a power of
                  attorney. We may also follow up with you to verify your
                  identity before processing the authorized agent’s request as
                  permitted by applicable law.
                </p>
                <p>
                  Please note that certain information may be exempt from such
                  requests under applicable law. For example, we may retain
                  certain information for legal compliance and to secure our
                  Services. We also may need certain information in order to
                  provide the Services to you; if you ask us to delete it, you
                  may no longer be able to use the Services.
                </p>
                <p>
                  You also have the right not to be discriminated against (as
                  provided for in applicable law) for exercising your rights.
                </p>
                <p>
                  You may also have the right to opt out of sales of your
                  personal information, or the sharing of your personal
                  information with targeted advertising providers. To opt out of
                  any future targeted advertising we may offer, please use the
                  tools described in the section above on Online Analytics and
                  Tailored Advertising, or in our{" "}
                  <Link onClick={toTop} to="/">
                    Cookie Policy
                  </Link>
                  . We may “sell” information about you to certain partners such
                  as our GoFundMe Pro Clients to help them understand your
                  likely interests in making charitable or other donations, the
                  potential size of such donations, or your interests in
                  starting peer-to-peer fundraisers, signing up for recurring
                  donations or other similar indicators. To opt out of “sales”
                  of your personal information that do not involve cookies or
                  other online tracking technologies, please complete this{" "}
                  <Link onClick={toTop} to="/">
                    form
                  </Link>
                  .
                </p>
                <p>
                  If you would like information regarding your rights under
                  applicable law or would like to exercise any of them, contact
                  us at the email address or mailing address set forth under “
                  <a href="#h2-number-17">Contacting GoFundMe</a>” or you may
                  submit your request by filling out this{" "}
                  <Link onClick={toTop} to="/privacy">
                    form
                  </Link>
                  . For your own privacy and security, at our discretion, we may
                  require you to provide your identity before providing the
                  requested information. To protect your privacy and security,
                  we take reasonable steps to verify your identity and requests
                  before granting such requests. If we are unable to verify your
                  identity, we may be unable to respond to your requests.
                </p>
                <p>
                  Depending on applicable law, if we deny your request, you may
                  have the right to appeal our decision to deny your request.
                  You may appeal that decision within 90 days by emailing us at{" "}
                  <Link onClick={toTop} to="mailto:legal@gofundme.com">
                    legal@gofundme.com
                  </Link>
                  . If, after we have processed your appeal, you are still
                  unsatisfied with our response, you may have the right to file
                  a complaint with your state attorney general.
                </p>
                <p>
                  <strong>Regional Privacy Disclosures and Rights</strong>.
                  Additional disclosures for residents of the European Economic
                  Area, Australia, United Kingdom, Switzerland, California,
                  Colorado, and Nevada are set forth below in Regional Privacy
                  Disclosures.
                </p>
                <h2 id="h2-number-16">REGIONAL PRIVACY DISCLOSURES</h2>
                <h3>USERS IN EUROPE AND UNITED KINGDOM</h3>
                <h3 style={{ paddingLeft: 40 }}>
                  A. Users in Europe and United Kingdom
                </h3>
                <p style={{ paddingLeft: 40 }}>
                  If you are in the European Economic Area (“EEA”) or
                  Switzerland (collectively “Europe”) and have used the GoFundMe
                  Services under a contractual relationship under the Terms of
                  Service with GoFundMe Ireland, then for the purposes of the
                  GDPR and the Swiss Federal Act of 19 June 1992 on Data
                  Protection (FADP) and the Privacy and Electronic
                  Communications Directive 2002/58/EC on Privacy and Electronic
                  Communications (ePrivacy Directive), the data controller is
                  GoFundMe Ireland Limited. If you are in the United Kingdom and
                  have used the GoFundMe Services under a contractual
                  relationship under the Terms of Service with GoFundMe
                  International Services UK Ltd., then for the purposes of the
                  UK GDPR, the data controller is GoFundMe International
                  Services UK Ltd. Data controllers can be reached at the
                  address set out at “Contacting GoFundMe” below.
                </p>
                <ul>
                  <li style={{ listStyleType: "none" }}>
                    <ul>
                      <li style={{ listStyleType: "none" }}>
                        <ul>
                          <li>
                            For the Users in the EEA that do not fall under the
                            previous paragraph, and to the extent that this
                            would be required by GDPR, GoFundMe Ireland also
                            acts as representative in the EU of GoFundMe Inc.
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
                <p style={{ paddingLeft: 40 }}>
                  If you are located in Europe, our legal grounds for processing
                  your information may be as follows:
                </p>
                <ul>
                  <li style={{ listStyleType: "none" }}>
                    <ul>
                      <li style={{ listStyleType: "none" }}>
                        <ul>
                          <li>
                            Consent: Where you have given consent to such
                            processing for one or more specific purposes.
                          </li>
                          <li>
                            Contractual Obligation: Where the processing is
                            necessary for the performance of a contract with
                            you.
                          </li>
                          <li>
                            Legal Obligation: Where processing is necessary for
                            compliance with our legal obligation.
                          </li>
                          <li>
                            Legitimate Interest: Where processing is necessary
                            for our legitimate interests or the legitimate
                            interests of our Users and your interests and
                            fundamental rights and freedoms do not override
                            those interests.
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
                <p>
                  We transfer your personal data to third countries subject to
                  appropriate safeguards, such as standard contractual clauses.
                </p>
                <p>{/* wp:table */}</p>
                <figure className="wp-block-table">
                  <style>{`
                    .custom-privacy-table {
                      width: 100%;
                      border-collapse: collapse;
                      border: 2px solid #000;
                      font-family: inherit;
                      margin: 0 0 1rem 0;
                    }
                    .custom-privacy-table th,
                    .custom-privacy-table td {
                      border: 1px solid #000;
                      padding: 18px 16px;
                      text-align: left;
                      vertical-align: middle;
                      font-size: 15px;
                      line-height: 1.35;
                    }
                    .custom-privacy-table thead th {
                      background: #ffffff;
                      font-weight: 700;
                    }
                    .custom-privacy-table thead th:first-child {
                      background: #ffb84d; /* orange highlight */
                      color: #000;
                      padding: 10px 16px;
                      text-transform: none;
                    }
                    .custom-privacy-table tbody tr td:first-child {
                      padding-left: 18px;
                      font-weight: 600;
                    }
                    /* make rows evenly spaced like the image */
                    .custom-privacy-table tbody tr td {
                      padding-top: 14px;
                      padding-bottom: 14px;
                    }
                  `}</style>
                  <table className="has-fixed-layout custom-privacy-table">
                    <thead>
                      <tr>
                        <th>Processing Activity</th>
                        <th>Legal Basis</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Providing our Services</td>
                        <td>Contract fulfillment</td>
                      </tr>
                      <tr>
                        <td>Identity Verification</td>
                        <td>
                          Contract fulfillment; legal obligation; legitimate
                          interest
                        </td>
                      </tr>
                      <tr>
                        <td>Fundraising campaign management</td>
                        <td>Contract fulfillment; legal obligation</td>
                      </tr>
                      <tr>
                        <td>Donation collection</td>
                        <td>Contract fulfillment</td>
                      </tr>
                      <tr>
                        <td>Measuring and reporting on campaign performance</td>
                        <td>Contract fulfillment; legitimate interest</td>
                      </tr>
                      <tr>
                        <td>
                          Improving our website and Services; product research
                        </td>
                        <td>Legitimate interest</td>
                      </tr>
                      <tr>
                        <td>Placement of analytics and advertising cookies</td>
                        <td>Consent</td>
                      </tr>
                      <tr>
                        <td>Use of chatbots</td>
                        <td>Contract fulfillment</td>
                      </tr>
                    </tbody>
                  </table>
                </figure>
                <p>&nbsp;</p>
                <p>
                  Residents of Europe also have the right to lodge a complaint
                  with the local data protection authority if you believe that
                  we have not complied with applicable data protection laws. You
                  also have the right to lodge a complaint with the supervisory
                  authority of your residence, place of work or where the
                  incident took place. However, we encourage you to contact us
                  first, and we will do our very best to resolve your concern.
                </p>
                <p>
                  The Irish Data Protection Commissioner shall act as the
                  competent lead supervisory authority for Users in the European
                  Economic Area, and you have the right to lodge a complaint
                  with your local data protection authority (see list in the
                  link here{" "}
                  <Link onClick={toTop} to="/">
                    home
                  </Link>
                  .) The Information Commissioner’s Office shall act as the
                  competent supervisory authority for users in the United
                  Kingdom and the Data Protection and Information Commissioner
                  (FDPIC) for Switzerland.
                </p>
                <h3 style={{ paddingLeft: 40 }}>B. Users in Australia</h3>
                <p style={{ paddingLeft: 40 }}>
                  If you are a User in Australia, you also have the right to
                  lodge a complaint with the local data protection authority if
                  you believe that we have not complied with applicable data
                  protection laws, and you have the right to lodge a complaint
                  with the supervisory authority of your residence, place of
                  work or where the incident took place. However, we encourage
                  you to contact us first, and we will do our very best to
                  resolve your concern.
                </p>
                <h3 style={{ paddingLeft: 40 }}>C. Residents of Nevada</h3>
                <p style={{ paddingLeft: 40 }}>
                  If you are a resident of Nevada, you have the right to opt-out
                  of the sale of certain personal information to unaffiliated
                  parties. You can exercise this right by contacting us as
                  described in the “Contacting GoFundMe” section below with the
                  subject line “Nevada Do Not Sell Request” and providing us
                  with your name and the email address. We do not currently sell
                  your personal information as sales are defined in Nevada
                  Revised Statutes Chapter 603A.
                </p>
                <h3 style={{ paddingLeft: 40 }}>D. Residents of Colorado</h3>
                <p style={{ paddingLeft: 40 }}>
                  Please refer to the chart accessible{" "}
                  <a href="/privacy#ccpachart">here</a>, under the California
                  Consumer Privacy Act Notice, for additional disclosures about
                  the purposes for which we use each category of information we
                  collect from and about you.
                </p>
                <h3 style={{ paddingLeft: 40 }}>E. Residents of California</h3>
                <p style={{ paddingLeft: 40 }}>
                  California’s Shine the Light Law (CA Civil Code § 1798.83)
                  allows California residents with which a business has an
                  established business relationship to request a list of the
                  third parties to which the business has disclosed certain
                  “personal information” (as specifically defined by the Shine
                  the Light law) during the preceding year where the business
                  knows or reasonably should know that the third parties used
                  the personal information for the third parties’ own “direct
                  marketing purposes,” defined by the Shine the Light law as the
                  use of personal information to solicit or induce a purchase,
                  rental, lease, or exchange of products, goods, property, or
                  services directly to individuals by means of the mail,
                  telephone, or electronic mail for their personal, family, or
                  household purposes. However, the business is not required to
                  provide this information where the business adopts and
                  discloses, in its privacy policy, a policy of not disclosing
                  “personal information” to third parties for their “direct
                  marketing purposes” 1) unless the resident first affirmatively
                  agrees or 2) if the resident has exercised an option that
                  prevents that information from being disclosed. GoFundMe
                  maintains such a policy and thus is not required to provide
                  this information. While GoFundMe does not engage in any
                  disclosures in which it knows or reasonably should know that
                  the third parties use the personal information for their own
                  direct marketing purposes as defined by Shine the Light,
                  GoFundMe understands that California residents have separate
                  rights under the California Consumer Privacy Act (“CCPA”) to
                  opt out of “sales” and “sharing” of their personal information
                  for cross-context behavioral advertising. Please click{" "}
                  <Link onClick={toTop} to="/">
                    Your Privacy Choices
                  </Link>{" "}
                  and follow the directions to exercise your Do Not Sell or Do
                  Not Share rights under the CCPA.
                </p>
                <p style={{ paddingLeft: 40 }}>
                  Please click{" "}
                  <Link onClick={toTop} to="/privacy">
                    here
                  </Link>{" "}
                  for additional disclosures applicable to residents of
                  California.
                </p>
                <h3 style={{ paddingLeft: 40 }}>
                  F. Residents of Oregon and Minnesota
                </h3>
                <p style={{ paddingLeft: 40 }}>
                  Residents of Minnesota and Oregon have the right to request a
                  list of “third parties” (as that term is defined under the
                  Minnesota Consumer Data Privacy Act and the Oregon Consumer
                  Privacy Act) to whom we have disclosed your personal
                  information.
                </p>
                <h2 id="h2-number-17">OTHER TERMS</h2>
                <p>
                  Your access to and use of the Services is subject to
                  GoFundMe’s{" "}
                  <Link onClick={toTop} to="/terms">
                    Terms of Service
                  </Link>{" "}
                  and such other terms, which may be made available to you in
                  connection with your use of the Services.
                </p>
                <h2 id="h2-number-18">CHANGES TO GOFUNDME’S PRIVACY NOTICE</h2>
                <p>
                  GoFundMe reserves the right to update or modify this Notice at
                  any time and from time to time. We will notify you of any
                  material updates or changes we make to this Notice. If you
                  disagree with our revisions to the Notice, you can deactivate
                  your account or discontinue the use of our Services. Please
                  review this Notice periodically for any updates or changes to
                  this Notice with a “Last Updated” effective date for the
                  revisions.
                </p>
                <p>
                  By using the Services after any such update or modification,
                  you acknowledge that you have read and understood the terms of
                  the Notice as updated or modified.
                </p>
                <h2 id="h2-number-19">CONTACTING GOFUNDME</h2>
                <p>
                  Please note that the Privacy Team and Data Protection Officer
                  are only able to handle data privacy related inquiries.
                  Consequently, if your e-mail concerns anything else, you may
                  not receive a response. For non-privacy related inquiries,
                  please visit the{" "}
                  <Link
                    onClick={toTop}
                    to="https://support.gofundme.com/hc/en-us"
                  >
                    Help Center
                  </Link>
                  .
                </p>
                <p>
                  To contact our Data Protection Officer, please email{" "}
                  <Link onClick={toTop} to="mailto:dpo@gofundme.com">
                    dpo@gofundme.com
                  </Link>
                  .
                </p>
                <p>
                  To submit a Data Subject Request, please fill out{" "}
                  <Link onClick={toTop} to="/privacy">
                    this form
                  </Link>{" "}
                  or email{" "}
                  <Link onClick={toTop} to="mailto:legal@gofundme.com">
                    legal@gofundme.com
                  </Link>
                  .
                </p>
                <p>You can also contact us via mail as follows:</p>
                <p>
                  For users in the USA and the rest of the world (except Europe
                  and the UK):
                </p>
                <p>
                  GoFundMe Inc.
                  <br />
                  ℅ Legal Department
                  <br />
                  PO Box 121270
                  <br />
                  815 E Street
                  <br />
                  San Diego, CA, 92101
                  <br />
                  United States
                </p>
                <p>For users in Europe:</p>
                <p>
                  GoFundMe Ireland, Limited,
                  <br />
                  ℅ Legal Department
                  <br />
                  70 Sir John Rogerson Quay,
                  <br />
                  Dublin 2, Ireland.
                </p>
                <p>
                  For users in the UK:
                  <br />
                  <span style={{ fontSize: "1rem", letterSpacing: 0 }}>
                    GoFundMe International Services UK Ltd
                    <br />
                  </span>
                  Rutland House, 148 Edmund Street
                  <br />
                  <span style={{ fontSize: "1rem", letterSpacing: 0 }}>
                    Birmingham, B32JR
                  </span>
                </p>
                <p>
                  View the{" "}
                  <Link onClick={toTop} to="/">
                    previous version
                  </Link>{" "}
                  of GoFundMe’s Privacy Notice.{/* /wp:table */}
                </p>
              </div>
              <div className="sidebar">
                <div className="sidebar-inner">
                  <div
                    ref={linkListRef}
                    className={`link-list custom-links-false ${
                      tocOpen ? "open" : "collapsed"
                    }`}
                  >
                    <div className="sidebar-title">
                      <button
                        type="button"
                        className="toc-toggle"
                        onClick={() => {
                          setTocOpen((v) => !v);
                          // trigger recalc/scroll handlers after DOM updates so fixed state updates immediately
                          window.setTimeout(() => {
                            window.dispatchEvent(new Event("resize"));
                            window.dispatchEvent(new Event("scroll"));
                          }, 0);
                        }}
                        aria-expanded={tocOpen}
                        aria-controls="terms-toc-list"
                      >
                        <span>Table of Contents</span>
                        <span className="toc-icon" aria-hidden="true">
                          {tocOpen ? "−" : "+"}
                        </span>
                      </button>
                    </div>
                    <ul id="terms-toc-list" className="toc-list">
                      <li>
                        <a href="#h2-number-1">Our Privacy Notice</a>
                      </li>
                      <li>
                        <a href="#h2-number-2">GOFUNDME IS A PUBLIC PLATFORM</a>
                      </li>
                      <li>
                        <a href="#h2-number-3">INFORMATION WE COLLECT</a>
                      </li>
                      <li>
                        <a href="#h2-number-4">
                          OUR USE OF INFORMATION COLLECTED
                        </a>
                      </li>
                      <li>
                        <a href="#h2-number-5">
                          OUR DISCLOSURE OF INFORMATION COLLECTED ABOUT YOU
                        </a>
                      </li>
                      <li>
                        <a href="#h2-number-6">VOLUNTEERED INFORMATION</a>
                      </li>
                      <li>
                        <a href="#h2-number-7">
                          ONLINE ANALYTICS AND TARGETED ADVERTISING
                        </a>
                      </li>
                      <li>
                        <a href="#h2-number-8">CHILDREN</a>
                      </li>
                      <li>
                        <a href="#h2-number-9">LINKS TO OTHER WEBSITES</a>
                      </li>
                      <li>
                        <a href="#h2-number-10">
                          CONTENT HOSTED ON OTHER WEBSITES
                        </a>
                      </li>
                      <li>
                        <a href="#h2-number-11">SECURITY</a>
                      </li>
                      <li>
                        <a href="#h2-number-12">
                          RETENTION OF YOUR INFORMATION
                        </a>
                      </li>
                      <li>
                        <a href="#h2-number-13">CROSS-BORDER DATA TRANSFERS</a>
                      </li>
                      <li>
                        <a href="#h2-number-14">
                          USERS FROM OUTSIDE THE UNITED STATES
                        </a>
                      </li>
                      <li>
                        <a href="#h2-number-15">YOUR PRIVACY RIGHTS</a>
                      </li>
                      <li>
                        <a href="#h2-number-16">REGIONAL PRIVACY DISCLOSURES</a>
                      </li>
                      <li>
                        <a href="#h2-number-17">OTHER TERMS</a>
                      </li>
                      <li>
                        <a href="#h2-number-18">
                          CHANGES TO GOFUNDME’S PRIVACY NOTICE
                        </a>
                      </li>
                      <li>
                        <a href="#h2-number-19">CONTACTING GOFUNDME</a>
                      </li>
                    </ul>
                  </div>
                  <div className="sidebar-cta">
                    <Link
                      onClick={toTop}
                      className="hrt-secondary-button hrt-secondary-button--gray hrt-secondary-button--full-for-small hrt-secondary-button--large hrt-base-button"
                      to="/"
                    >
                      Start a GoFundMe
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <p />
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;
